import React, { PureComponent } from "react";
import styled, { css, withTheme } from "styled-components";
import { cssMainSelector } from "../../../../../lib/cssSelectors";
import FilterPanelContainer from "../../../../../containers/FilterPanelContainer";
import MediaContainer from "../../../../MediaContainer";
import SponsoredPositionContainer from "../../../../../containers/SponsoredPositionContainer";
import OfferResultsContainer from "../../../../../containers/OfferResultsContainer";
import { PrimaryButton } from "../../../../Button";
import { withTranslation } from "react-i18next";
import MaterialIcon from "../../../../MaterialIcon";
import { MODALS } from "../../../../../constants/modals";
import CurrentResultsCountContainer from "../../../../../containers/CurrentResultsCountContainer";
import NonDefaultFiltersLineContainer from "../../../../../containers/NonDefaultFiltersLineContainer";
import MobileFilterPanel from "../../../../MobileFilterPanel";
import PhoneChangerContainer from "../../../../../containers/PhoneChangerContainer";
import PhoneInfoBarContainer from "../../../../../containers/PhoneInfoBarContainer";
import PhonePickerButtonContainer from "../../../../../containers/PhonePickerButtonContainer";
import CreditWarning from "../../../../CreditWarning";
import { OFFER_TYPES } from "../../../../../constants/offerTypes";

const Container = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    display: flex;
    min-width: ${(p) => p.theme.generic.minWidgetWidth || "310px"};
    max-width: ${(p) => p.theme.generic.maxWidgetWidth || "1500px"};
  }
`;

const FilterPanelWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    order: 0;
    padding-right: ${(p) => p.theme.spacing.sm};
  }

  ${(p) => cssMainSelector(p.theme.tdsId, { mediaSizeName: "lgtablet-down" })} {
    display: none;
  }
`;

const PhoneChangerWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    border-color: ${(p) => p.theme.filter.secondaryFiltersBorderColor};
    border-radius: ${(p) => p.theme.generic.borderRadius}
      ${(p) => p.theme.generic.borderRadius} 0 0;
    border-style: solid;
    border-width: 1px 1px 0 1px;
    padding: ${(p) => p.theme.spacing.md};
    text-align: center;
  }
`;

const ContentWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    order: 1;
  }
`;

const Header = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    order: 0;
    padding-bottom: ${(p) => p.theme.spacing.sm};
  }
`;

const CreditWarningWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    padding-bottom: ${(p) => p.theme.spacing.sm};
  }
`;

const PhoneInfoBarWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    padding-bottom: ${(p) => p.theme.spacing.sm};

    &:empty {
      display: none;
    }
  }
`;

const MobileFilterPanelWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    display: none;
    padding-bottom: ${(p) => p.theme.spacing.sm};
  }

  ${(p) => cssMainSelector(p.theme.tdsId, { mediaSizeName: "lgtablet-down" })} {
    display: block;
  }
`;

const NonDefaultFiltersLineWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
  }
`;

const ResultsInfoWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    align-items: flex-start;
    display: flex;
    flex-wrap: wrap-reverse;
    justify-content: space-between;
  }
`;

const currentResultsCountWrapperPadding = css`
  padding: ${(p) => p.theme.spacing.sm} ${(p) => p.theme.spacing.md} 0 0;
`;
const CurrentResultsCountWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    order: 0;
    padding: 0;
  }

  ${(p) => cssMainSelector(p.theme.tdsId, { mediaSizeName: "lgtablet-down" })} {
    ${currentResultsCountWrapperPadding};
  }
`;

const ResultsInfoButtonsWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    display: flex;
    flex: 1 1 auto;
    flex-wrap: wrap-reverse;
    justify-content: flex-end;
    order: 1;
  }
`;

const SortWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    order: 1;
  }
`;

const PhonePickerButtonWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    display: none;
    order: 2;
    padding-right: ${(p) => p.theme.spacing.md};
  }

  ${(p) => cssMainSelector(p.theme.tdsId, { mediaSizeName: "lgtablet-down" })} {
    display: block;
  }
`;

const FilterButton = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    display: none;
    order: 3;

    * {
      color: ${(p) => p.theme.color.white};
      font-weight: ${(p) => p.theme.font.weightBold};
    }
  }

  ${(p) => cssMainSelector(p.theme.tdsId, { mediaSizeName: "lgtablet-down" })} {
    display: block;
  }
`;

const resultsWrapperPadding = css`
  padding: ${(p) => p.theme.spacing.md} ${(p) => p.theme.spacing.md};
`;
const ResultsWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    background-color: ${(p) => p.theme.offerResults.blockBackgroundColor};
    ${resultsWrapperPadding};
    order: 1;
  }
`;

class WidgetLayout extends PureComponent {
  render() {
    const {
      clientConfig,
      offerType,
      portal,
      sponsoredPositionCount,
      t,
      theme,
      updateExperiment,
      updateModal,
      widgetOptions,
    } = this.props;

    return (
      <Container>
        <FilterPanelWrapper>
          {theme.phoneChanger.show && (
            <PhoneChangerWrapper>
              <PhoneChangerContainer />
            </PhoneChangerWrapper>
          )}
          <FilterPanelContainer />
        </FilterPanelWrapper>
        <ContentWrapper>
          <Header>
            {theme.phoneInfoBar.show && (
              <PhoneInfoBarWrapper>
                <PhoneInfoBarContainer />
              </PhoneInfoBarWrapper>
            )}
            <MobileFilterPanelWrapper>
              <MobileFilterPanel
                clientConfig={clientConfig}
                offerType={offerType}
                updateModal={updateModal}
              />
            </MobileFilterPanelWrapper>
            {sponsoredPositionCount > 0 &&
              offerType === OFFER_TYPES.proposition && (
                <CreditWarningWrapper>
                  <CreditWarning portal={portal} />
                </CreditWarningWrapper>
              )}
            <NonDefaultFiltersLineWrapper>
              <NonDefaultFiltersLineContainer />
            </NonDefaultFiltersLineWrapper>
            <ResultsInfoWrapper>
              <CurrentResultsCountWrapper>
                <CurrentResultsCountContainer />
              </CurrentResultsCountWrapper>
              <ResultsInfoButtonsWrapper>
                <SortWrapper />
                <PhonePickerButtonWrapper>
                  <PhonePickerButtonContainer />
                </PhonePickerButtonWrapper>
                <FilterButton>
                  <PrimaryButton
                    onClick={updateModal.bind(
                      this,
                      { noData: "required" },
                      MODALS.filterModal
                    )}
                  >
                    <MaterialIcon>filter_list</MaterialIcon>{" "}
                    {t("shared.filter")}
                  </PrimaryButton>
                </FilterButton>
              </ResultsInfoButtonsWrapper>
            </ResultsInfoWrapper>
          </Header>
          <ResultsWrapper>
            <MediaContainer>
              <SponsoredPositionContainer
                clientConfig={clientConfig}
                offerType={offerType}
                portal={portal}
                updateExperiment={updateExperiment}
                updateModal={updateModal}
                widgetOptions={widgetOptions}
              />
              <OfferResultsContainer
                clientConfig={clientConfig}
                offerType={offerType}
                portal={portal}
                updateExperiment={updateExperiment}
                updateModal={updateModal}
                widgetOptions={widgetOptions}
              />
            </MediaContainer>
          </ResultsWrapper>
        </ContentWrapper>
      </Container>
    );
  }
}

export default withTranslation(["inDepthDefault"])(withTheme(WidgetLayout));
